import React from 'react';
import { Link } from 'react-router';
import AgreementReceipt from '../../../agreementReceipt.jsx';

import Page from '../../../page.jsx';
import { data as agreementDataPropTypes } from '../../../agreementPropTypes';
import partnerPropTypes from '../../../partnerPropTypes';
import { formatDate } from '../../../getDeadline.js';

const WaitingForPayment = ({ agreement, partner }) => (
    <Page heading={`Venter på betaling fra ${partner.name}`}>
        <div>
            <p>
                {partner.name} må betale til FINN innen
                <span className="strong">
                    {' '}
                    {formatDate(agreement.paymentDeadline)}
                </span>. Vent med å sende varen til vi gir beskjed om at vi har
                fått pengene.
            </p>

            <div className="r-phl r-pbl">
                <AgreementReceipt
                    agreement={agreement}
                    partner={partner}
                    role="SELLER"
                />
            </div>

            <div className="r-pal">
                <Link to="/samtale" className="button fullwidth">
                    OK
                </Link>
            </div>
        </div>
    </Page>
);

WaitingForPayment.propTypes = {
    agreement: agreementDataPropTypes.isRequired,
    partner: partnerPropTypes.isRequired,
};

export default WaitingForPayment;



// WEBPACK FOOTER //
// ./safeTrade/seller/agreement/statusDetails/waitingForPayment.jsx